
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-settings-3-line',
      title: 'IT Consulting & Strategy',
      description: 'Strategic technology planning and consulting to align IT infrastructure with business objectives and drive digital transformation.',
      features: ['Technology Assessment', 'Strategic Planning', 'Digital Roadmap', 'Risk Analysis']
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Migration Services',
      description: 'Seamless cloud migration and optimization services to improve scalability, reduce costs, and enhance business agility.',
      features: ['Cloud Assessment', 'Migration Planning', 'AWS/Azure/GCP', 'Cost Optimization']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Solutions',
      description: 'Comprehensive security solutions to protect your business from cyber threats and ensure regulatory compliance.',
      features: ['Security Audits', 'Threat Detection', 'Compliance', 'Incident Response']
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Custom Software Development',
      description: 'Tailored software solutions designed to meet your specific business requirements and improve operational efficiency.',
      features: ['Web Applications', 'Mobile Apps', 'API Development', 'System Integration']
    },
    {
      icon: 'ri-database-2-line',
      title: 'Data Analytics & BI',
      description: 'Transform your data into actionable insights with advanced analytics and business intelligence solutions.',
      features: ['Data Visualization', 'Predictive Analytics', 'Dashboard Creation', 'Reporting Tools']
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Managed IT Services',
      description: '24/7 IT support and management services to ensure your systems run smoothly and efficiently at all times.',
      features: ['24/7 Support', 'System Monitoring', 'Maintenance', 'Help Desk']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Expert Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive IT solutions tailored to your business needs, from strategic consulting to hands-on technical support
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-100">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                <a href="#contact" className="text-blue-600 font-medium hover:text-blue-700 transition-colors">
                  Learn More <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
